import React from 'react';
import ActiveLink from '../../layout/ActiveLink';
import styles from './Styles.module.css';
import { useWindowSize } from 'usehooks-ts';
import Typography from 'common/components/tags/typography/Typography';
import clsx from 'clsx';
import { Swiper, SwiperSlide } from 'swiper/react';

export interface props {
  links: {
    title: string;
    href?: string;
    id?: string;
    isActive?: boolean;
    onClick?: (value: string | undefined) => void;
  }[];
  title?: string;
  value?: string;
  className?: string;
  titleClassName?: string;
}

const CategoryLinks = ({
  title,
  links,
  value,
  className,
  titleClassName,
}: props) => {
  const { width } = useWindowSize();

  return (
    <div className={clsx(className, 'category-list-slider pt-4 md:pr-[1rem]')}>
      {title && (
        <Typography variant='h4-card' className={titleClassName}>
          {title}
        </Typography>
      )}
      {width > 767 ? (
        <ul>
          {links.map(({ href, title, onClick, id, isActive }) => (
            <li
              className='webkit-line-clamp-1 my-1 md:my-4 xl:my-6'
              key={id ?? title}
            >
              {href ? (
                <ActiveLink activeClassName={styles['active']} href={href}>
                  <span
                    className={clsx(
                      styles['title-link'],
                      isActive && styles['active']
                    )}
                  >
                    {title}
                  </span>
                </ActiveLink>
              ) : (
                onClick && (
                  <span
                    className={clsx(
                      styles['title-link'],
                      ((id ?? title) === value || isActive) && styles['active']
                    )}
                    onClick={() => onClick(id)}
                  >
                    {title}
                  </span>
                )
              )}
            </li>
          ))}
        </ul>
      ) : (
        <Swiper className='py-3' slidesPerView={'auto'}>
          {links.map(({ href, title, onClick, id, isActive }) =>
            href ? (
              <SwiperSlide key={id ?? title}>
                <ActiveLink activeClassName={styles['active']} href={href}>
                  <span
                    className={clsx(
                      styles['title-link'],
                      isActive && styles['active']
                    )}
                  >
                    {title}
                  </span>
                </ActiveLink>
              </SwiperSlide>
            ) : (
              onClick && (
                <SwiperSlide key={id ?? title}>
                  <span
                    className={clsx(
                      styles['title-link'],
                      ((id ?? title) === value || isActive) && styles['active']
                    )}
                    onClick={() => onClick(id)}
                  >
                    {title}
                  </span>
                </SwiperSlide>
              )
            )
          )}
        </Swiper>
      )}
    </div>
  );
};

export default CategoryLinks;
